import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../appStore";
import LocalTokenService from "../../services/localTokenService";
import {UserResponse} from "../../models/UserResponses";
import {Profile} from "../../models/Profile";
import {ClearMenuItems, ReLoadMenuItems} from "../../components/Layout/MasterLayout/SideMenuItems";

export const DEFAULT_AUTH_STATE= { profile: null, token:null, refreshToken:null, refreshTokenExpiryTime:null, subMenu:[] } as AuthState;

const localAuth = LocalTokenService.getToken();

type AuthState = {
    profile: Profile | null
    token: string | null
    refreshToken: string | null,
    refreshTokenExpiryTime: Date | null,
    subMenu:any
}
//TODO: remove this and use authService.ts
export const SLICE_AUTH_NAME = "auth";
const slice = createSlice({
    name: SLICE_AUTH_NAME,
    initialState: { profile: localAuth.profile, token: localAuth.token, refreshToken: localAuth.refreshToken, refreshTokenExpiryTime: localAuth.refreshTokenExpiryTime, subMenu:[] } as AuthState,
    reducers: {
        setCredentials: ( state, { payload: { profile, token, refreshToken, refreshTokenExpiryTime } }: PayloadAction<UserResponse>) => {
            state.profile = profile;
            state.token = token;
            state.refreshToken = refreshToken;
            state.refreshTokenExpiryTime = refreshTokenExpiryTime;
            LocalTokenService.setToken({profile, token, refreshToken, refreshTokenExpiryTime });
            ReLoadMenuItems();
        },
        setUserProfile:( state, { payload }: PayloadAction<any>) => {
            state.profile = payload;
        },
        setSubMenu:( state, { payload }: PayloadAction<any>) => {
            state.subMenu = payload;
        },
        logOut:() => {
            ClearMenuItems();
            LocalTokenService.setToken({...DEFAULT_AUTH_STATE });
            return DEFAULT_AUTH_STATE;
        }
    },
})

export const { setCredentials, setUserProfile, logOut, setSubMenu } = slice.actions

export default slice.reducer

export const selectProfile = (state: RootState) => state[SLICE_AUTH_NAME].profile;

export const selectAuthState= (state: RootState) => state[SLICE_AUTH_NAME];

export const selectSubMenu = (state: RootState) => state[SLICE_AUTH_NAME].subMenu;
